export default __webpack_public_path__ + "static/media/masterLogo.d674e003.png";